document.querySelectorAll('#quickview-product-content .quick-order-list-container').forEach(function(el) {
  el.remove();
});

// Select the quick-order-list-container element
var quickOrderListContainer = document.querySelector('.quick-order-list-container');

// Check if the element exists
if (quickOrderListContainer) {
  // Set the display property to 'block'
  quickOrderListContainer.style.display = 'block';
} else {
  console.warn('quick-order-list-container not found');
}

// Initialize an empty array to store the variant IDs
var productVariantIds = [];

// Select all elements with the class 'variant-item'
var bundleElements = document.querySelectorAll('.variant-item.variantBundle');

// Select all quantity buttons
var variantQtBtns = document.querySelectorAll('.quantity.cart-quantity button');

function TotalVariantPriceFn() {
  // Initialize the total price
var totalVariantPrice = 0;
  var totalQty = 0;
  // Loop through bundle elements to calculate the price
    bundleElements.forEach(function(element) {
      var inputElement = element.querySelector('.quantity.cart-quantity input');
      var variantPrice = parseFloat(element.getAttribute('data-price-id')); // Ensure the price is a number

      if (!inputElement) {
        // console.warn("Input field not found for element:", element);
        return;
      }

      var variantQTY = parseInt(inputElement.value || 0, 10); // Ensure quantity is a number

       // console.log("variantQTY -->", variantQTY);

      // Calculate total price for this variant
      // Skip adding to totalQty if variantQTY is negative
      if (variantQTY >= 0) {
        totalQty += variantQTY;
        totalVariantPrice += variantPrice * variantQTY; // Calculate total price for this variant
      }
    });
  //console.log("totalQty -->", totalQty);
    setTimeout(function(){
      DisCalculation(totalQty);
    }, 500);
  

    // Log the total price after all calculations
    // console.log("Total Variant Price -->", totalVariantPrice);

    // Perform additional operations (e.g., updating the DOM)
    var totalPriceElement = document.querySelector('.product-page.main-product .main-product-price .price');
    if (totalPriceElement) {
      totalPriceElement.textContent = `$${totalVariantPrice.toFixed(2)}`;
    }
}

TotalVariantPriceFn();

// Loop through each button and add a click event listener
variantQtBtns.forEach(function(button) {
  button.addEventListener('click', function(e) {
    // Delay the calculation to allow the browser to update the input value
    setTimeout(function() {
    
    TotalVariantPriceFn();
       }, 10); // Delay execution to ensure the input value is updated
  });
});


// Example of using the array to add items to the cart
document.getElementById('add-bundle-to-cart').addEventListener('click', function(e) {
  e.preventDefault();
  e.stopImmediatePropagation(); // Prevent other listeners from triggering
  var productVariantIds = [];
// console.log("add-bundle-to-cart click");
  // Loop through each bundle element and get the variant ID
  bundleElements.forEach(function(element) {
    var variantId = element.getAttribute('data-variant-id');
    var inputElement = element.querySelector('.quantity.cart-quantity input');
    var variantPrice = element.getAttribute('data-price-id');
    
    if (!inputElement) {
      console.warn("Input field not found for element:", element);
      return;
    }
  
    var variantQTY = inputElement.value || 0; // Default to 0 if value is empty
    
    if (variantId) {
      // Add the variant ID and quantity to the array
      productVariantIds.push({ id: variantId, quantity: parseInt(variantQTY, 10) });
    }
  
     console.log("variantQTY -->", variantQTY);
  });

  
  // Now `productVariantIds` contains an array of all variant IDs in the bundle
 // console.log(productVariantIds); // Check the array in the console
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: productVariantIds })
  })
  .then(response => response.json())
  .then(data => {
      // console.log('Bundle added to cart:', data);
       //window.location.href = '/cart'; // Redirect to cart page
      Alpine.store('xMiniCart').openCart();
      if (Alpine.store('xMiniCart')) {
        Alpine.store('xMiniCart').needReload = true;
        Alpine.store('xMiniCart').reLoad();
      }
  })
  .catch(error => {
    console.error('Error adding bundle to cart:', error);
  });
});

if($('.discountedPrice').length == 0){
  $('<span class="discountedPrice"></span>').insertAfter($('.product-page.main-product .main-product-price'));
}
function DisCalculation(totalQty) {
 var qtyVal = totalQty;
  // console.log('qtyVal==>', qtyVal);
  // Stop the functionality if totalQty is less than or equal to 0
  //console.log('hulk Div==>', $(".hulkapps-table tbody tr").length);
  if (parseInt(qtyVal) <= 0) {
    if($(".hulkapps-table tbody tr").length == 0){
     $('.product-page.main-product .main-product-price').css('text-decoration', '').show(); // show the original price 
    }
    $('.discountedPrice').hide(); // Hide the discounted price
    return; // Exit the function
  }
  // Show prices if the condition above is not met
   //$('.product-page.main-product .main-product-price').show();
  $('.discountedPrice').show();
 // Loop through the table rows to calculate and apply discounts
  $(".hulkapps-table tbody tr").each(function() {
    var firstQtyLevel = $(".hulkapps-table tbody tr:first").find("td:first-child").text();
    // console.log('firstQtyLevel==>', firstQtyLevel);
    if(firstQtyLevel.includes('-')){
      var offersMinVal = $(".hulkapps-table tbody tr:first").find("td:first-child").text().split('-')[0];
      var offersForMinVal = $(this).find("td:first-child").text().split('-')[0];
    }
    if(firstQtyLevel.includes('+')){
      var offersMinVal = $.trim($(".hulkapps-table tbody tr:first").find("td:first-child").text().replace('Buy','').replace('+',''));
      var offersForMinVal = $.trim($(this).find("td:first-child").text().replace('Buy','').replace('+',''));
    }
    // console.log('offersMinVal==>', offersMinVal, "offersForMinVal -->", offersForMinVal);

    if (parseInt(qtyVal) >= parseInt($.trim(offersMinVal)) && parseInt(qtyVal) >= parseInt($.trim(offersForMinVal))) {
      var offerPrice = $(this).find('.hulkapps-price .money').text().replace('$', '');
      var qtyMultiOffer = (parseFloat(offerPrice) * parseFloat(qtyVal)).toFixed(2);

     // $('.product-page.main-product .main-product-price .price').css('text-decoration', 'line-through');
      $('.discountedPrice').text('$' + qtyMultiOffer);
    } else if (parseInt(qtyVal) < $.trim(offersMinVal)) {
     // $('.product-page.main-product .main-product-price .price').css('text-decoration', '');
      $('.discountedPrice').text('');
    }
  });
}
$('body').on('input', '.quantity.cart-quantity input', function() {
    TotalVariantPriceFn();
});